import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";
import { BitbucketLogoBrand } from "@/libraries/wpl/foundations/src/logos/bitbucket-logo-brand";
import { CompassLogoBrand } from "@/libraries/wpl/foundations/src/logos/compass-logo-brand";
import { SourcetreeLogoBrand } from "@/libraries/wpl/foundations/src/logos/sourcetree-logo-brand";
import {
    TryPageCard,
    TryPageHeader
} from "@/templates/try/try-page/components";

import { messages } from "../messages";

const sectionCss = css({
    padding: "32px 0",
    position: "relative",
    verticalAlign: "baseline",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%"
});

const CodeBuildShipSection = () => {
    const intl = useIntl();

    const codeBuildShipHeaderText = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.headerText",
        defaultMessage: "Code, Build, & Ship"
    });

    const bitbucketBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.bitbucket.bodyText",
        defaultMessage:
            "Collaborate on code with inline comments and pull requests. Manage and share your Git repositories to build and ship software, as a team."
    });

    const sourcetreeBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.sourcetree.bodyText",
        defaultMessage:
            "Harness the full power of Git and Mercurial in a beautifully simple application. Get the free desktop client for Mac and Windows."
    });

    const compassBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.compass.bodyText",
        defaultMessage:
            "Bring your distributed software architecture and the teams that collaborate on it together in a single, unified place."
    });

    const tryCloud = intl.formatMessage(messages.tryCloud);

    const downloadNow = intl.formatMessage(messages.downloadNow);

    return (
        <UFOSegment css={sectionCss} name={"code-build-ship"}>
            <Row>
                <TryPageHeader
                    dividerColor={"#ff8b00"}
                    headerText={codeBuildShipHeaderText}
                />
            </Row>
            <Row layout="6-6">
                <TryPageCard
                    logo={<BitbucketLogoBrand />}
                    link={useLocalizedHref("/software/bitbucket/bundle")}
                    bodyText={bitbucketBody}
                    ctaText={tryCloud}
                />
                <TryPageCard
                    logo={<SourcetreeLogoBrand />}
                    link={"https://www.sourcetreeapp.com/"}
                    bodyText={sourcetreeBody}
                    ctaText={downloadNow}
                />
            </Row>
            <div />
            <Row layout="6-6">
                <TryPageCard
                    logo={<CompassLogoBrand />}
                    link={useLocalizedHref("/try/cloud/signup?bundle=compass")}
                    bodyText={compassBody}
                    ctaText={tryCloud}
                />
                <div />
            </Row>
        </UFOSegment>
    );
};

export default CodeBuildShipSection;
